"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteEntityDocument = exports.uploadEntityDocument = exports.postEntityBankAccount = exports.postEntity = exports.getEntities = void 0;
const getEntities = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/entities`, {
  withCredentials: true
});
exports.getEntities = getEntities;
const postEntity = (serverURL, appAxios) => async entity => await appAxios.post(`${serverURL}/entities`, entity, {
  withCredentials: true
});
exports.postEntity = postEntity;
const postEntityBankAccount = (serverURL, appAxios) => async (entityId, bankAccount) => await appAxios.post(`${serverURL}/entities/${entityId}/bank-account`, bankAccount, {
  withCredentials: true
});
exports.postEntityBankAccount = postEntityBankAccount;
const uploadEntityDocument = (serverURL, appAxios) => async (entityId, file, documentType) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("documentType", documentType);
  return await appAxios.post(`${serverURL}/entities/${entityId}/document/upload`, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
exports.uploadEntityDocument = uploadEntityDocument;
const deleteEntityDocument = (serverURL, appAxios) => async (entityId, documentId) => await appAxios.get(`${serverURL}/entities/${entityId}/document/${documentId}/delete`, {
  withCredentials: true
});
exports.deleteEntityDocument = deleteEntityDocument;